
class MobileAppAllController {
    /*@ngInject*/

    constructor(Auth, $state, User, Modal, $translate, BranchService, $q, $scope, MobileAppService) {
        this.MobileAppService = MobileAppService;
        this.apps = [];
    }

    $onInit() {
        this.loadData();
    }

    loadData() {
        this.loading = true;
        this.MobileAppService.getAll()
            .then((data) => {
                this.apps = data;
                this.loading = false;
                if (this.apps && this.apps.android) {
                    this.androidData = this.apps.android;
                }
                // if (this.apps && this.apps.ios) {
                //     this.iosData = this.apps.ios;
                // }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                this.loading = false;
            })
    }
}

export default MobileAppAllController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/mobile_app/all/mobile_app.all.controller.js